import PropTypes from 'prop-types';
import StoreType from 'types/store';
import FlagType from 'types/flag';
import EventType from 'types/event';
import TaskType from 'types/task';
import poShape from 'types/purchaseOrder';

const Phase = {
  id: PropTypes.number,
  type: PropTypes.string,
  due_at: PropTypes.string,
  effective_due_at: PropTypes.string,
  customer_name: PropTypes.string,
  lrrp_required: PropTypes.bool,
  project_number: PropTypes.string,
  purchase_orders: PropTypes.arrayOf(PropTypes.shape(poShape)),
  status_name: PropTypes.string,
  street_address: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip_code: PropTypes.string,
  store: StoreType,
  surface_type: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  flags: PropTypes.arrayOf(FlagType),
  phone_numbers: PropTypes.arrayOf(PropTypes.shape({
    number: PropTypes.string,
    kind: PropTypes.string,
    reached: PropTypes.bool,
    ok_to_text: PropTypes.bool,
  })),
  related_po: PropTypes.string,
};

const PhaseDetails = {
  ...Phase,
  email: PropTypes.string,
  mode_of_contact: PropTypes.string,
  date_sold: PropTypes.string,
  associate: PropTypes.string,
  contractor_notes: PropTypes.string,
  additional_comments: PropTypes.string,
  surface_information: PropTypes.object,
  created_at: PropTypes.string,
  status: PropTypes.string,
  available_statuses: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  estimator_id: PropTypes.number,
  installer_id: PropTypes.number,
  year_built: PropTypes.number,
  sqft: PropTypes.number,
  haul_away: PropTypes.string,
  additional_work: PropTypes.string,
  events: PropTypes.arrayOf(EventType),
  current_tasks: PropTypes.arrayOf(TaskType),
  verified_assessment_document_id: PropTypes.number,
  net_square_footage: PropTypes.number,
  floor_wizard_job: PropTypes.shape({
    id: PropTypes.number,
    floor_wizard_project_id: PropTypes.string,
  }),
};

const PhaseIndexType = PropTypes.shape(Phase);
const PhaseDetailsType = PropTypes.shape(PhaseDetails);

export default PhaseDetailsType;

export { PhaseIndexType, PhaseDetailsType };



// WEBPACK FOOTER //
// ./client/app/shared/types/phase.js